'use client';

import { isReviewStep, type ReviewStepSlotProps, type StepperFormBodyProps } from '../types';

export type { StepperFormBodyProps };

export const StepperFormBody = ({
	stepTitle,
	stepContent: StepContent,
	slotProps,
	reviewProps,
	showStepHeader = true,
	stepDescription,
}: StepperFormBodyProps) => {
	const showHeader = showStepHeader && (stepDescription || stepTitle) && !isReviewStep(stepTitle);

	const reviewSlotProps: ReviewStepSlotProps | null = reviewProps
		? {
				...slotProps,
				sections: reviewProps.sections,
				goToStep: reviewProps.goToStep,
				submitError: reviewProps.submitError,
				isSubmitting: reviewProps.isSubmitting,
			}
		: null;

	return (
		<div className="flex w-full min-h-[400px] flex-col spacing-stack-l">
			<div className="flex w-full flex-col pb-[70px] max-lg:pb-0">
				{showHeader ? (
					<div className="flex flex-col spacing-heading-m spacing-stack-m">
						{stepTitle ? <h2 className="text-h4 text-text-heading">{stepTitle}</h2> : null}
						{stepDescription ? (
							<p className="text-body1 text-text-primary">{stepDescription}</p>
						) : null}
					</div>
				) : null}
				<div className="flex flex-col gap-[20px] lg:gap-[30px]">
					{reviewSlotProps ? <StepContent {...reviewSlotProps} /> : <StepContent {...slotProps} />}
				</div>
			</div>
		</div>
	);
};
